import { render } from "./ResetPasswordModal.vue?vue&type=template&id=7ef1c818&ts=true"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__